<div class="message" [class.message--blue]="color() === 'blue'">
  <i class="pi message__icon" [class.pi-exclamation-triangle]="type() === 'alert'"></i>
  <div class="message__text">
    <ng-content></ng-content>
  </div>
</div>
